import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import MenuPage from "./pages/MenuPage";

const API = "/api";

export const SettingsContext = createContext({ menuVisible: true });

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ menuVisible: true });
  useEffect(() => {
    fetch(`${API}/site-settings`)
      .then((r) => r.json())
      .then((d) => setSettings({ menuVisible: d.menu_visible !== false }))
      .catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const MenuGate = () => {
  const { menuVisible } = useSettings();
  return menuVisible ? <MenuPage /> : <Navigate to="/order?menu=hidden" replace />;
};
